module.exports = __webpack_public_path__ + "img/plus-white.0ce3e24c.svg";